import {BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError} from '@reduxjs/toolkit/query/react'
import { RootState } from '../..';
import Constants from "expo-constants";
import {notification} from "antd";

export class PagedTableDto {
  page: number;
  sortedColumn: string;
  sortedColumnAscending: boolean;
  filters: any;

  constructor(page: number, filters: any, sortedColumn?: string, sortedColumnAscending?: boolean) {
    this.page = page;
    this.filters = filters;
    this.sortedColumn = sortedColumn;
    this.sortedColumnAscending = sortedColumnAscending;
  }


  getFilters(): string {
    var filterString = "";
    if (this.sortedColumn != null) { filterString += `sortedColumn=${this.sortedColumn}&` }
    if (this.sortedColumnAscending != null) { filterString += `sortedColumnAscending=${this.sortedColumnAscending}&` }

    for (let key in this.filters) {
      var value = this.filters[key];
      if (value != null && value != "") {
        filterString += `${key}=${value}&`
      }
    }

    return filterString;
  }
}

// @ts-ignore
export const baseUrl = Constants.expoConfig.baseUrl;

export type TagType = 'Ticket'
  | 'WorkOrder'
  | 'WorkOrderChild'
  | 'WorkOrderAsset'
  | 'WorkOrderLog'
  | 'WorkOrderLabour'
  | 'JobPlan'
  | 'PreventativeMaintenance'
  | 'Asset'
  | 'AssetTypes'
  | 'SubAssetTypes'
  | 'Building'
  | 'FallOut'
  | 'User';

export const apiTagTypes: TagType[] =
  [
    'Ticket',
    'WorkOrder',
    'WorkOrderAsset',
    'WorkOrderLog',
    'WorkOrderLabour',
    'WorkOrderChild',
    'JobPlan',
    'PreventativeMaintenance',
    'Asset',
    'AssetTypes',
    'SubAssetTypes',
    'Building',
    'FallOut',
    'User'
  ];

const baseQueryWithErrorNotification:
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (args, api, extraOptions) => {
  const baseQuery = fetchBaseQuery({
    baseUrl: `${baseUrl}api/`,
    prepareHeaders: (headers, { getState }) => {
      var user = (getState() as RootState).user;
      if (user == null) {
        return headers;
      }

      const token = user.token;
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }

      return headers
    },
  });

  const result = await baseQuery(args, api, extraOptions);

  if (result.error) {
    const { data } = result.error;
    const message = getErrorMessage(data);

    notification.error({
      message: `Error`,
      description: message,
      placement: 'bottomRight',
      duration: 3,
    });
  }

  return result;
};

const getErrorMessage = (data: unknown): string => {
  if (typeof data === 'string' && data.trim().length > 0) {
    return data;
  }

  if (data && typeof data === 'object') {
    const problem = data as { detail?: unknown; title?: unknown; message?: unknown; errors?: unknown };

    if (typeof problem.detail === 'string' && problem.detail.trim().length > 0) {
      return problem.detail;
    }

    if (typeof problem.title === 'string' && problem.title.trim().length > 0) {
      return problem.title;
    }

    if (typeof problem.message === 'string' && problem.message.trim().length > 0) {
      return problem.message;
    }

    if (problem.errors && typeof problem.errors === 'object') {
      return Object.values(problem.errors as Record<string, unknown>)
        .flatMap(value => Array.isArray(value) ? value : [value])
        .filter((value): value is string => typeof value === 'string' && value.trim().length > 0)
        .join(', ') || 'An unexpected error occurred!';
    }
  }

  return 'An unexpected error occurred!';
};

// initialize an empty api service that we'll inject endpoints into later as needed
export const baseApi = createApi({
  baseQuery: baseQueryWithErrorNotification,
  tagTypes: apiTagTypes,
  keepUnusedDataFor: 0,
  endpoints: () => ({}),
})
